import React from 'react';
const JoinUs = () => {
    return (
        <div className="request-form">
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <h4>READY TO JOIN OUR CREATIVE FAMILY?</h4>
                        <span>Whether you're interested in our technical workshops, want to participate in competitions, or join our community service projects, we're here to welcome you!</span>
                    </div>
                    <div className="col-md-4">
                        <a href="/JoinUs" className="border-button">Join Creative Lab</a>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default JoinUs;